import { setup } from "web/entrypoints/common/setup";
import "./css-curated-collection";
import { curatedCollectionComponents } from "./curated-collection";

setup(curatedCollectionComponents);
